var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#282D3C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3.994 10.833C2.868 8.926 2.124 6.706 1.82 4.234c-.046-.377-.07-.566-.04-.808.092-.762.76-1.516 1.504-1.7.237-.06.477-.06.956-.06v0c.426 0 .639 0 .826.037a2 2 0 0 1 1.436 1.12c.08.173.132.38.235.793l.054.217c.208.831.312 1.247.33 1.654a4 4 0 0 1-.48 2.073c-.194.358-.47.686-1.022 1.342zm0 0a14.54 14.54 0 0 0 4.887 5m0 0c1.97 1.223 4.289 2.028 6.884 2.347.378.046.567.07.81.04.76-.093 1.515-.76 1.7-1.505.058-.237.058-.485.058-.98v0c0-.41 0-.614-.036-.802a2 2 0 0 0-1.12-1.435c-.174-.08-.38-.132-.793-.235l-.305-.077c-.882-.22-1.323-.33-1.757-.343a4 4 0 0 0-1.767.357c-.396.18-.76.452-1.487.996z"
  })));
};
export default SvgPhone;